import { render, staticRenderFns } from "./WarehouseAddModal.vue?vue&type=template&id=35bf4d44&scoped=true&"
import script from "./WarehouseAddModal.vue?vue&type=script&lang=js&"
export * from "./WarehouseAddModal.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseAddModal.vue?vue&type=style&index=0&id=35bf4d44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf4d44",
  null
  
)

export default component.exports